// DMV-focused SEO blog content for Capital Corner Group.
// Written to rank for real Washington DC / Maryland / Northern Virginia real-estate searches,
// referencing our real listings and video marketing.

export const brokerOpens = [
  {
    id: "bo-film-2",
    title: "Broker Open Film",
    location: "Sold in 2.5 \u2013 5 days on market",
    orientation: "landscape",
    video: "/broker-open-2.mp4",
    blurb: "Our cinematic broker open film \u2014 the kind of launch that sells a home in under a week.",
  },
  {
    id: "bo-5940",
    title: "5940 Broker Open",
    location: "Bethesda, MD",
    orientation: "portrait",
    video: "/broker-5940.mp4",
    blurb: "A cinematic broker open that put a Bethesda listing in front of the region's top agents in a single afternoon.",
  },
  {
    id: "bo-mclean",
    title: "McLean Estate Showcase",
    location: "McLean, VA",
    orientation: "landscape",
    video: "/broker-mclean.mp4",
    blurb: "Full sound-design production for a McLean estate — the kind of media that makes a listing impossible to ignore.",
  },
  {
    id: "bo-french",
    title: "Frenchway Open House",
    location: "Washington, DC",
    orientation: "landscape",
    video: "/broker-french.mp4",
    blurb: "An open house film that turned a DC residence into a destination event and drove qualified foot traffic.",
  },
];

export const blogCategories = ["Buying", "Selling", "Marketing", "Market Trends"];

// Vertical social reels for the Media page
export const socialReels = [
  "/reelA.mp4",
  "/reelB.mp4",
  "/reelC.mp4",
];

export const blogPosts = [
  {
    slug: "buying-a-home-in-washington-dc-2026-neighborhood-guide",
    title: "Buying a Home in Washington, DC: A 2026 Neighborhood Guide",
    category: "Buying",
    date: "June 2, 2026",
    readTime: "6 min read",
    author: "Capital Corner Group",
    cover: "https://photos.zillowstatic.com/fp/db1865f98dd1d209725f96984562d85f-cc_ft_960.jpg",
    excerpt:
      "From Capitol Hill row homes to Connecticut Avenue condos, here is how to choose the right DC neighborhood in 2026 — and what your money actually buys today.",
    keywords: ["homes for sale in Washington DC", "DC neighborhoods 2026", "buy a home in DC"],
    sections: [
      { h: "Why Washington, DC is still a buyer's long game", p: [
        "Washington, DC remains one of the most resilient housing markets in the country. A diversified economy anchored by government, law, healthcare, and a fast-growing tech corridor keeps demand steady even when interest rates move. For buyers, that stability means a DC home is rarely just a purchase — it is a long-term asset in a market that has historically held its value through every cycle.",
        "In 2026 we are seeing well-priced, move-in-ready homes trade quickly, while properties that need work sit longer and reward patient, prepared buyers. The single biggest advantage you can have is a local team that knows which blocks are appreciating and which listings are priced to move.",
      ]},
      { h: "Neighborhoods to watch in 2026", p: [
        "Kalorama and Woodley Park continue to command a premium for their embassy-row elegance and walkability — a home like 1933 Calvert St NW captures exactly that blend of historic character and modern finishes. Buyers who want turnkey luxury with a park at their doorstep should look here first.",
        "For value with upside, Northeast and Southeast DC — think Brookland, Deanwood, and the corridors around 2411 Savannah St SE — offer newer construction and more square footage per dollar, with infrastructure investment steadily lifting the whole area.",
        "If low-maintenance living is the goal, boutique condos along Connecticut Avenue NW (like 5305 Connecticut Ave NW) put you minutes from Rock Creek Park and the Metro without the upkeep of a full house.",
      ]},
      { h: "How to win in a competitive DC offer", p: [
        "Get fully underwritten before you shop, not just pre-qualified. Understand the difference between fee-simple and condo ownership, and factor DC's recordation and transfer taxes into your budget from day one. Finally, work with an advisor who can move fast — in DC, the best homes are often gone within a week.",
      ]},
    ],
    relatedIds: [1005, 1006, 1008],
  },
  {
    slug: "selling-your-home-in-alexandria-arlington-va",
    title: "Selling Your Home in Alexandria & Arlington, VA: What Actually Moves the Needle",
    category: "Selling",
    date: "May 21, 2026",
    readTime: "5 min read",
    author: "Capital Corner Group",
    cover: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
    excerpt:
      "Northern Virginia sellers have real leverage in 2026 — if the home is prepared, priced, and marketed correctly. Here is the Capital Corner playbook.",
    keywords: ["sell my house in Alexandria VA", "Arlington VA real estate agent", "home selling tips Northern Virginia"],
    sections: [
      { h: "Northern Virginia is still a seller's market — with conditions", p: [
        "Proximity to Amazon HQ2, the Pentagon, and the Metro Silver Line keeps Alexandria and Arlington in perpetual demand. But 2026 buyers are more discerning than they were during the frenzy years. Homes that are staged, professionally marketed, and priced to the current comps still sell fast and often above ask. Homes that are overpriced or poorly presented linger — and every week on market costs you leverage.",
      ]},
      { h: "Presentation is marketing, and marketing is price", p: [
        "The listings that break records for us are the ones we treat like a product launch. That means professional photography, drone and cinematic video, and a broker open that gets the region's most active agents through the door before the public ever sees it. When we brought a Sterling and Alexandria portfolio to market, that media-first approach is what created competition — and competition is what drives price.",
      ]},
      { h: "Pricing strategy for VA sellers in 2026", p: [
        "Price to the last 60 days of comparable sales, not to last year's peak. A sharp, defensible list price generates more showings in week one — which is when your best offers arrive. We build a custom pricing and net-proceeds analysis for every seller so you know your number before we ever go live.",
      ]},
    ],
    relatedIds: [1016, 1013, 1019],
  },
  {
    slug: "the-power-of-a-broker-open-in-the-dmv",
    title: "No One Does Broker Opens Like Us: The Power of Cinematic Marketing in the DMV",
    category: "Marketing",
    date: "May 8, 2026",
    readTime: "4 min read",
    author: "Capital Corner Group",
    cover: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
    excerpt:
      "A broker open is not a party — it is a distribution strategy. Here is how our cinematic open houses put DMV listings in front of the right buyers first.",
    keywords: ["broker open house DMV", "real estate video marketing Washington DC", "luxury listing marketing"],
    sections: [
      { h: "The first showing begins online", p: [
        "Ninety-plus percent of buyers start their search on a screen. That is why every Capital Corner listing launches with a cinematic film — sound-designed, color-graded, and built to stop the scroll. Our McLean and Frenchway open house productions are not afterthoughts; they are the opening move that shapes how the entire market perceives a home.",
      ]},
      { h: "Why the broker open still wins", p: [
        "Before a listing hits the public portals, we gather the region's most productive agents in one room. Those agents carry active, qualified buyers. A single well-produced broker open can generate more serious interest in an afternoon than weeks of passive listing exposure — and it creates the urgency that leads to strong, fast offers.",
      ]},
      { h: "Media that follows the buyer everywhere", p: [
        "The same footage that fuels the broker open is cut into vertical reels for social, embedded on the property page, and shared directly with our buyer database. One shoot, distributed across every channel a DMV buyer actually uses. See the work on our broker opens page — it speaks for itself.",
      ]},
    ],
    relatedIds: [1001, 1005, 1017],
  },
  {
    slug: "bethesda-chevy-chase-md-luxury-market-trends-2026",
    title: "Bethesda & Chevy Chase, MD Luxury Market Trends for 2026",
    category: "Market Trends",
    date: "April 26, 2026",
    readTime: "5 min read",
    author: "Capital Corner Group",
    cover: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
    excerpt:
      "Montgomery County's luxury corridor is entering 2026 with tight inventory and motivated, well-qualified buyers. Here is what sellers and buyers should know.",
    keywords: ["Bethesda MD luxury homes", "Chevy Chase real estate 2026", "Montgomery County market trends"],
    sections: [
      { h: "Tight inventory, disciplined buyers", p: [
        "Bethesda and Chevy Chase remain the gold standard for Maryland luxury — top-ranked schools, a walkable downtown, and a straight shot into DC. Inventory at the upper end stays tight, which protects values, but 2026 buyers are underwriting carefully. They will pay a premium for finished, thoughtfully updated homes and negotiate hard on anything dated.",
      ]},
      { h: "Where the value is", p: [
        "Boutique condo communities such as 5301 Westbard Cir offer an accessible entry point into the Bethesda lifestyle, while larger single-family homes toward the Chevy Chase line continue to appreciate. Buyers priced out of turnkey estates are increasingly targeting renovation candidates in prime locations — location first, condition second.",
      ]},
      { h: "The 2026 outlook", p: [
        "Expect steady, sustainable appreciation rather than the double-digit spikes of prior years. For sellers that means pricing precision matters more than ever; for buyers it means real opportunity in a market that finally rewards preparation over speed. Either way, a local advisor who tracks these micro-markets daily is your biggest advantage.",
      ]},
    ],
    relatedIds: [1003, 1009],
  },
];
